// Texte imprime en bas du ticket par le POS quand la company n'a pas de
// description propre (Company.ticket_footer vide) — COPIE de
// DEFAULT_TICKET_FOOTER dans lottery-app/src/utils/printer.js, a garder
// IDENTIQUE. Partage par Mon Compte (company) et le formulaire company du
// superadmin (2026-09-26).
export const DEFAULT_TICKET_FOOTER =
  'La fiche est payable au porteur\net seulement au porteur une et\nune fois. Le montant gagne devra\netre reclame avant 90 jours';
